import React from 'react';
import { Route } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import WebsiteSortContainer from './WebsiteSort';

export const WebsiteSortModule = () => (
  <Route exact path={APP_ROUTES.WEBSITE_SORT_MODULE.PATH} component={WebsiteSortContainer} />
);
